// import { Box, Center, Heading, Image, Text } from '@chakra-ui/react';
import homevideo from '../videos/HomeVideoEdited.mp4'

export const Home=()=>{
    return (
        <div id="home">
            {/* <Box display={{base:'none', md:'block'}} backgroundImage={frequencywave} h={'90%'} w={'100%'}>
            <Center>
            <Heading fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }} mt={'200px'}>
              <Text
                as={'span'}
                position={'relative'}
                color='#D8D8D8'
                _after={{
                  content: "''",
                  width: 'full',
                //   height: useBreakpointValue({ base: '20%', md: '30%' }),
                  position: 'absolute',
                  bottom: 1,
                  left: 0,
                  bg: '#4FC3F7',
                  zIndex: -1,
                }}>
                Hi👋, I'm
              </Text>
              <br />{' '}
              <Text id="user-detail-name" color={'#4FC3F7'} colorScheme='secondary' as={'span'}>
                Rutuvik Patil
              </Text>{' '}
            </Heading>
            </Center>
            </Box>
            <Box display={{base:'block', md:'none'}} backgroundImage={frequencywavemed} h={'90%'} w={'100%'}>
            <Center>
            <Heading fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }} mt={'200px'}>
              <Text
                as={'span'}
                position={'relative'}
                color='#D8D8D8'
                _after={{
                  content: "''",
                  width: 'full',
                //   height: useBreakpointValue({ base: '20%', md: '30%' }),
                  position: 'absolute',
                  bottom: 1,
                  left: 0,
                  bg: '#4FC3F7',
                  zIndex: -1,
                }}>
                Hi👋, I'm
              </Text>
              <br />{' '}
              <Text id="user-detail-name" color={'#4FC3F7'} colorScheme='secondary' as={'span'}>
                Rutuvik Patil
              </Text>{' '}
            </Heading>
            </Center>
            </Box> */}
            <video autoPlay muted loop width={'100%'}>
              <source src={homevideo} />
            </video>
        </div>
    )
};